import type { BadgeTone } from '../components/ui/Badge'

export type Health = 'healthy' | 'watch' | 'critical'

export function pastDueHealth(pct: number): Health {
  if (pct <= 10) return 'healthy'
  if (pct <= 20) return 'watch'
  return 'critical'
}

export function speedHealth(seconds: number): Health {
  if (seconds <= 300) return 'healthy'
  if (seconds <= 600) return 'watch'
  return 'critical'
}

export function contactRateHealth(pct: number): Health {
  if (pct >= 40) return 'healthy'
  if (pct >= 30) return 'watch'
  return 'critical'
}

export const healthTone: Record<Health, BadgeTone> = {
  healthy: 'positive',
  watch: 'warning',
  critical: 'critical',
}

export const healthText: Record<Health, string> = {
  healthy: 'text-emerald-700',
  watch: 'text-amber-700',
  critical: 'text-rose-700',
}

export const healthBar: Record<Health, string> = {
  healthy: 'bg-emerald-500',
  watch: 'bg-amber-500',
  critical: 'bg-rose-500',
}
